import { render } from "./addComponent.vue?vue&type=template&id=2c8aa13c"
import script from "./addComponent.vue?vue&type=script&lang=js"
export * from "./addComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__